<!-- 项目选择list -->
<template>
  <div>
    <div class="choose-menu">
      <zlr-menu :menuList="menuList"></zlr-menu>
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
// components

import ZlrMenu from '@/components/menu/menu-row'

export default {
  name: 'project-choose-list',
  components: {
    ZlrMenu
  },
  data () {
    return {
      menuList: [
        {
          title: '项目初览',
          name: ['project-choose-preview-list']
        },
        {
          title: '选校方案',
          name: ['project-choose-scheme-list']
        },
        {
          title: '项目协议',
          name: ['project-choose-agree-list']
        }
      ]
    }
  },
  computed: {},
  mounted () { },
  methods: {
  }
}
</script>
<style lang='less' scoped>
</style>
